<template>
  <a-spin tip="Your document is being processed, do not leave this page!" :spinning="loading.pageLoading">
    <a-config-provider :locale="getLocalConfigProvider()">
      <a-card>
        <span slot="title">Tax Release</span>
        <div slot="extra">
          <div style="display: flex;">
            <a-input-search v-model="search" placeholder="Quick Search" size="small" />
            &nbsp;&nbsp;
            <a-button @click="reload" size="small" icon="reload"></a-button>
          </div>
        </div>
        <a-tabs class="custom-tabs" :activeKey="tabs.active" @change="handleTab">
          <a-tab-pane v-if="!onlyViews" key="need_process">
            <template slot="tab">
              <span>Need Process</span>
              <a-badge class="m-badge m-badge-small" :count="dataSource.needProcess.length"
                :numberStyle="{ backgroundColor: 'red' }" v-if="dataSource.needProcess.length > 0">
              </a-badge>
            </template>
            <a-table :rowKey="(record, index) => {
              return index.toString();
            }
              " size="small" bordered :scroll="{ x: 850 }" :columns="columns.needProcess"
              :dataSource="dataSource.needProcess" :loading="tabs.loading" :pagination="pagination">
              <!--  :rowClassName="(record, index) => { return record.check == '1' ? 'selectedRow' : '' }" -->
              <template slot="nomor" slot-scope="text, data, index">
                <span>{{
                  (pagination.page - 1) * pagination.pageSize + index + 1
                }}</span>
              </template>
              <template slot="transno" slot-scope="data">
                <a v-if="data.type != 'tax_manual'" @click="goToMan(data)">{{ data.no }}</a>
                <span v-else>{{ data.no }}</span><br />
                <small><b>{{ data.type_label }}</b></small>
              </template>
              <template slot="description" slot-scope="data">
                {{ data.description }}
              </template>
              <template slot="value" slot-scope="data">
                <CurrencyJustified :currencyValue="'IDR'" :valueNumber="Number(data.value)" />
              </template>
              <template slot="remaining" slot-scope="data">
                <CurrencyJustified :currencyValue="'IDR'" :valueNumber="Number(data.remaining_balance)" />
              </template>
              <template slot="action" slot-scope="data">
                <a-button type="primary" @click="goToProcess(data)">
                  Process
                </a-button>
              </template>
            </a-table>
          </a-tab-pane>
          <a-tab-pane key="tax_release_list">
            <template slot="tab">
              <span>Tax Release List</span>
            </template>
            <a-table :rowKey="(record, index) => {
              return index.toString();
            }
              " size="small" bordered :scroll="{ x: 600 }" :columns="columns.list"
              :dataSource="dataSource.listtaxRelease" :loading="tabs.loading" :pagination="pagination">
              <!-- :rowClassName="(record, index) => { return record.check == '1' ? 'selectedRow' : '' }" -->
              <template slot="nomor" slot-scope="text, data, index">
                <span>{{
                  (pagination.page - 1) * pagination.pageSize + index + 1
                }}</span>
              </template>
              <template slot="ntr" slot-scope="data">
                <a @click="goToNTR(data)">{{ data.no_tax_release }}</a>
              </template>
              <template slot="transno" slot-scope="data">
                <a @click="goToMan(data)">{{ data.no_transaksi }}</a><br />
                <small><b>{{ data.jenis_transaksi_label }}</b></small>
              </template>
              <template slot="description" slot-scope="data">
                {{ data.description }}
              </template>
              <template slot="value" slot-scope="data">
                <CurrencyJustified :currencyValue="'IDR'" :valueNumber="Number(data.value)" />
              </template>
              <template slot="remaining" slot-scope="data">
                <CurrencyJustified :currencyValue="'IDR'" :valueNumber="Number(data.remaining_balance)" />
              </template>
              <template slot="updateby" slot-scope="data">
                {{ data.tlc_create }} / {{ moment(data.create_dt).format(getDefaultDateFormat) }}
              </template>
              <template slot="docbil" slot-scope="data">
                <a-button v-if="data.path_doc_id_billing" @click="viewDoc(data.path_doc_id_billing)" type="default">View
                  Doc</a-button>
                <span v-else> - </span>
              </template>
              <template slot="note" slot-scope="data">
                {{ data.catatan }}
              </template>
              <template slot="nobkk" slot-scope="data">
                <a @click="goToBKK(data.bkk_id)">{{ data.no_bkk }}</a>
              </template>
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </a-config-provider>

    <a-modal v-model="modalTaxVerification" v-if="modalTaxVerification" :maskClosable="false" :width="1024"
      :footer="null">
      <span slot="title"> <a-icon type="reconciliation" />&nbsp;Verification Transaction Tax
        {{ modalTax.jenis_transaksi_label }} # {{ modalTax.no_transaction }} </span>
      <div class="container-headertable">
        <div class="m-display-flex space-between align-middle">
          <span>List Details</span>
        </div>
      </div>
      <a-config-provider :locale="getLocalConfigProvider()">
        <a-table bordered size="small" id="tbl_dtl" :rowKey="(record, index) => { return index; }"
          :columns="modalTax.columns" :dataSource="modalTax.source" :pagination="modalTax.pagination" :scroll="{ x: 835 }"
          :loading="modalTax.loading">
          <template slot="nomor" slot-scope="text, data,index">
            <div class="m-text-align center">{{ index + 1 }}</div>
          </template>
          <template slot="detail" slot-scope="data">
            <div class="m-text-align left">{{ data.detail }}</div>
            <small v-if="data.kode_anggaran"><i>[{{ data.kode_anggaran + "-" + data.item_anggaran }}]</i></small>
          </template>
          <template slot="notrans" slot-scope="data">
            <div class="m-text-align center">{{ data.no_trans }}</div>
          </template>
          <template slot="type" slot-scope="data">
            <div class="m-text-align left">{{ gettitletax(data.tax_type) }}</div>
          </template>
          <template slot="dppvalue" slot-scope="data">
            <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.dpp_value" />
          </template>
          <template slot="value" slot-scope="data">
            <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.tax_value" />
          </template>
          <template slot="action" slot-scope="text,data,index">
            <div :class="'m-text-align center'">
              <a-button-group>
                <a-tooltip class="m-tooltip-inner" placement="bottomRight" title="View File">
                  <a-button :disabled="data.tax_document_name == '' || data.tax_document_name == null || loading.spinform"
                    type="default" @click="viewFiledtl(data.tax_document_name, data.tax_document_path)" icon="file"
                    size="small">
                  </a-button>
                </a-tooltip>
              </a-button-group>
            </div>
          </template>
        </a-table>
      </a-config-provider>
    </a-modal>

    <a-modal v-model="modalProcess.visible" v-if="modalProcess.visible" :maskClosable="false"
      :width="getScreen ? '80%' : '500px'">
      <span slot="title"> <a-icon type="reconciliation" />&nbsp;
        {{ modalProcess.mode == 'manifest' ? "Manifest Tax Release"
          : "Process Tax Release" }}</span>
      <a-spin tip="Your document is being processed, do not leave this page!" :spinning="modalProcess.loadingModal">
        <a-form :form="modalProcess.form" :layout="'inline'" v-bind="modalProcess.formItemLayout">
          <a-form-item label="No" class="m-width-full">
            <a-input disabled v-decorator="['no',
              { rules: [{ required: false }], initialValue: modalProcess.no }]" class="m-width-full">
            </a-input>
          </a-form-item>
          <a-form-item label="Description" class="m-width-full">
            <a-textarea disabled :rows="2"
              v-decorator="['description', { rules: [{ required: false }], initialValue: modalProcess.description }]" />
          </a-form-item>
          <a-form-item label="No Id Billing" class="m-width-full">
            <a-input v-decorator="['no_id_billing',
              { rules: [{ required: true }], initialValue: modalProcess.no_id_billing }]"
              :disabled="modalProcess.mode == 'manifest'">
            </a-input>
          </a-form-item>
          <a-form-item label="Value" class="m-width-full">
            <a-input-number type="number" class="m-width-full m-text-align-right"
              v-on:keydown.enter.prevent="preventEnterButton('create_note')" :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                " :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
    'value',
    {
      rules: [{ required: true, validator: checkPrice }],
      initialValue: modalProcess.value,
    },
  ]" :disabled="modalProcess.mode == 'manifest'" />
          </a-form-item>
          <a-form-item label="Note" class="m-width-full">
            <a-textarea :rows="2"
              v-decorator="['note', { rules: [{ required: false }], initialValue: modalProcess.note }]" ref="create_note"
              :disabled="modalProcess.mode == 'manifest'" />
          </a-form-item>
          <a-form-item label="Doc. Id Billing" class="m-width-full">
            <a-upload :fileList="modalProcess.fileList" v-decorator="[
              'doc_id_billing',
              {
                rules: [
                  { required: true, validator: doc_validation },
                ],
              },
            ]" :remove="handleRemoveAttachment" :beforeUpload="beforeUploadAttachment">
              <a-button :disabled="modalProcess.mode == 'manifest'"> <a-icon type="upload" />Select File </a-button>
            </a-upload>
          </a-form-item>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button @click="modalCancelProcess" type="danger" :hidden="modalProcess.mode == 'manifest'"
          :disabled="modalProcess.mode == 'manifest'">
          Cancel
        </a-button>
        <a-button @click="modalSaveProcess" type="primary" :hidden="modalProcess.mode == 'manifest'"
          :disabled="modalProcess.mode == 'manifest'" :loading="modalProcess.loadingSave">
          Save
        </a-button>
      </template>
    </a-modal>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod";
import HandleRoute from "@/mixins/HandleRoute";
import moment from "moment";
import _ from "lodash";

export default {
  name: "list-tax-verification",
  mixins: [GlobalMethod, HandleRoute],
  components: {},
  data() {
    const columns = {
      needProcess: [
        {
          title: "#",
          key: "nomor",
          align: "center",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },
        {
          title: "No",
          key: "transno",
          align: "left",
          scopedSlots: { customRender: "transno" },
          width: 250,
        },
        {
          title: "Description",
          key: "description",
          align: "left",
          scopedSlots: { customRender: "description" },
          width: 200,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 200,
        },
        {
          title: "Remaining Balance",
          key: "remaining",
          scopedSlots: { customRender: "remaining" },
          width: 200,
        },
        {
          title: "Action",
          key: "action",
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
          width: 100,
        },
      ],
      list: [
        {
          title: "#",
          key: "nomor",
          align: "center",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },
        {
          title: "No Tax Release",
          key: "ntr",
          align: "left",
          scopedSlots: { customRender: "ntr" },
          width: 250,
        },
        {
          title: "No transaction",
          key: "transno",
          align: "left",
          scopedSlots: { customRender: "transno" },
          width: 250,
        },
        {
          title: "Description",
          key: "description",
          align: "left",
          scopedSlots: { customRender: "description" },
          width: 200,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 200,
        },
        {
          title: "Remaining Balance",
          key: "remaining",
          scopedSlots: { customRender: "remaining" },
          width: 200,
        },
        {
          title: "Update By",
          key: "updateby",
          align: "center",
          scopedSlots: { customRender: "updateby" },
          width: 150,
        },
        {
          title: "Document Billing",
          key: "docbil",
          align: "center",
          scopedSlots: { customRender: "docbil" },
          width: 120,
        },
        {
          title: "Note",
          key: "note",
          scopedSlots: { customRender: "note" },
          width: 200,
        },
        {
          title: "No BKK",
          key: "nobkk",
          scopedSlots: { customRender: "nobkk" },
          width: 200,
        },
      ]
    };
    let doc_validation = (rule, value, callback) => {
      if (this.modalProcess.fileList && this.modalProcess.length == 0) {
        callback(new Error("Document Upload is Empty!"));
      } else {
        callback();
      }
    };
    return {
      search: undefined,
      doc_validation,
      columns,
      loading: {
        pageLoading: false,
      },
      tabs: {
        active: "need_process",
        loading: false,
      },
      search: undefined,
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      dataSource: {
        needProcess: [],
        needProcess_ori: [],
        listtaxRelease: [],
        listtaxRelease_ori: [],
      },
      modalTaxVerification: false,
      modalTax: {
        jenis_transaksi_label: "-",
        no_transaction: "",
        source: [],
        pagination: {
          onChange: (page) => {
            this.modalTax.pagination.page = page;
          },
          page: 1,
          pageSize: 10,
          size: "small",
        },
        columns: [
          {
            title: "#",
            key: "nomor",
            scopedSlots: { customRender: "nomor" },
            width: 50,
          },
          {
            title: "No. Transaction",
            key: "notrans",
            scopedSlots: { customRender: "notrans" },
            width: 150,
          },
          {
            title: "Detil transaction",
            key: "detail",
            scopedSlots: { customRender: "detail" },
            width: 250,
          },
          {
            title: "Type tax",
            key: "type",
            scopedSlots: { customRender: "type" },
            width: 150,
          },
          {
            title: "DPP Value",
            key: "dppvalue",
            scopedSlots: { customRender: "dppvalue" },
            width: 150,
          },
          {
            title: "Value",
            key: "value",
            scopedSlots: { customRender: "value" },
            width: 150,
          },
          {
            title: "View",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "action" },
            width: 85,
          },
        ],
      },
      modalProcess: {
        visible: false,
        form: this.$form.createForm(this),
        fileList: [],
        formItemLayout: {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 18 },
          },
        },
        loadingSave: false,
      }
    }
  },
  beforeCreate() {
  },
  mounted() {
    if(!this.onlyView)
      this.tabs.active="tax_release_list"
    this.reload();
  },
  beforeDestroy() {
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getType_tax"
    ]),
    onlyViews(){
      if(this.$route.meta && this.$route.meta.onlyView){
        return true
      }
      return false
    }
  },
  watch: {
    search() {
      if (this.search) {
        if (this.tabs.active == "need_process") {
          this.dataSource.needProcess = _.filter(this.dataSource.needProcess_ori, (el) =>
            el.no && el.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            el.description && el.description.toLowerCase().indexOf(this.search.toLowerCase()) >= 0);
        } else {
          this.dataSource.listtaxRelease = _.filter(this.dataSource.listtaxRelease_ori, (el) =>
            el.no_tax_release && el.no_tax_release.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            el.no_transaksi && el.no_transaksi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            el.catatan && el.catatan.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            el.description && el.description.toLowerCase().indexOf(this.search.toLowerCase()) >= 0);
        }
      } else {
        if (this.tabs.active == "need_process") {
          this.dataSource.needProcess = this.dataSource.needProcess_ori;
        } else {
          this.dataSource.listtaxRelease = this.dataSource.listtaxRelease_ori;
        }
      }
    },
  },
  created() {
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
    },
    handleTab(val) {
      this.tabs.active = val;
      this.resetSearch();
      this.reload()
    },
    async reload() {
      this.resetSearch();
      this.tabs.loading = true;
      await this.asyncAxiosGet("tax_release", this.getAuth, {
        tab: this.tabs.active
      })
        .then((res) => {
          if (this.tabs.active == "need_process") {
            this.dataSource.needProcess = res.need_process;
            this.dataSource.needProcess_ori = res.need_process;
          }
          if (this.tabs.active == "tax_release_list") {
            this.dataSource.listtaxRelease = res.tax_release_list;
            this.dataSource.listtaxRelease_ori = res.tax_release_list;
          }

          this.tabs.loading = false;
        })
        .catch((err) => {
          this.tabs.loading = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    goToNTR(item) {
      this.modalProcess.visible = true;
      this.modalProcess.mode = "manifest";
      this.modalProcess.no = item.no_tax_release;
      this.modalProcess.description = item.description;
      this.modalProcess.id = item.tax_release_id;
      this.modalProcess.value = item.value;
      this.modalProcess.note = item.catatan;
      this.modalProcess.no_id_billing = item.no_id_billing;

      this.modalProcess.loadingModal = true;
      this.asyncAxiosGet("main/base_64", this.getAuth, {
        path: item.document_path,
      })
        .then((response) => {
          let typefile = this.fileTypeFromUrl(item.doc_id_billing);
          let file = this.dataURLtoFile(
            typefile + response.file_document_tax,
            item.doc_id_billing
          );
          file.uid = "vc-upload-1-1";
          file.status = "done";
          file.url = this.$serviceUrl + item.path_doc_id_billing;
          this.modalProcess.fileList = [];
          this.modalProcess.fileList.push(file);
          this.modalProcess.loadingModal = false;
        })
        .catch((err) => {
          this.modalProcess.loadingModal = false;
          console.log(err);
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    goToMan(item) {
      let manifest = ""
      let type = item.type ? item.type : item.jenis_transaksi
      if (type == "pi") {
        manifest = "PiManifest";
        const route = this.$router.resolve({ name: manifest, params: { id: item.id_trans } });
        window.open(route.href, "_blank");
      } else if(type == "pi_release") {
        manifest = "ManifestPIRelease";
        const route = this.$router.resolve({ name: manifest, params: { id: item.id_trans } });
        window.open(route.href, "_blank");
      }else {
        let ids = (item.no_transaksi ? item.no_transaksi : item.no).split("/")
        let tipe = ids[2]
        if (tipe.toLowerCase() == "pph21") {
          tipe = "pph21"
        } else if (tipe.toLowerCase() == "ppn") {
          tipe = "ppn"
        } else if (tipe.toLowerCase() == "pphuni") {
          tipe = "unifikasi"
        }
        ids = ids[1].split(".")
        manifest = "SPTManifest";
        const route = this.$router.resolve({ name: manifest, params: { id: (item.id_trans ? item.id_trans : item.id), tipe: tipe } });
        window.open(route.href, "_blank");
      }
    },
    viewDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    goToBKK(id_trans) {
      let keubid = _.filter(this.getAuth.divisi, (e) => e.toLowerCase() == "keuangan").length > 0 ? true : false
      const route = this.$router.resolve({ name: (keubid ? "bkkManifestKeu" : "bkkManifestAcc"), params: { id: id_trans } });
      window.open(route.href, "_blank");
    },
    gettitletax(val) {
      let res = _.filter(this.getType_tax, (el) => el.value == val);
      return res.length > 0 ? res[0].text : "-";
    },
    goToProcess(item) {
      this.modalProcess.mode = "add";
      this.modalProcess.visible = true;
      this.modalProcess.loadingModal = false;
      this.modalProcess.no = item.no;
      this.modalProcess.value = item.remaining_balance;
      this.modalProcess.description = item.description;
      this.modalProcess.note = item.note ? item.note : item.description;
      this.modalProcess.id = item.id;
      this.modalProcess.fileList = [];
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    preventEnterButton(item) {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function () {
        this.$refs[item].focus();
      });
    },
    beforeUploadAttachment(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.modalProcess.fileList = [];
        this.modalProcess.fileList.push(file);
        return false;
      }
    },
    handleRemoveAttachment() {
      if (this.modalProcess.mode == 'manifest') {
        this.displayMessageValue("error-other", "File in Manifest Can't be deleted!");
      } else {
        this.modalProcess.fileList = [];
      }
    },
    modalSaveProcess() {
      this.modalProcess.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.modalProcess.loadingSave = true;
        let data = new FormData();
        data.append("id", this.modalProcess.id);
        data.append("no_id_billing", values.no_id_billing);
        data.append("value", values.value);
        data.append("note", values.note);
        data.append("doc_id_billing", this.modalProcess.fileList[0]);

        this.asyncAxiosPost("tax_release", "formdata", this.getAuth, data)
          .then((response) => {
            if (response.status == true) {
              this.displayMessageValue("success-other", response.message);
            } else {
              this.displayMessageValue(
                "error-other",
                response.message
              );
            }
            this.modalProcess.loadingSave = false;
            this.modalProcess.visible = false;
            this.modalProcess.mode = null;
            this.modalProcess.id = null;
            this.modalProcess.no = null;
            this.modalProcess.fileList = [];
            this.modalProcess.description = null;
            this.modalProcess.no_id_billing = null;
            this.reload();
          })
          .catch((err) => {
            console.log(err);
            this.modalProcess.loadingSave = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
            this.loading.addVarification = false;
          });
      });
    },
    modalCancelProcess() {
      this.modalProcess.visible = false;
      this.modalProcess.mode = null;
      this.modalProcess.id = null;
      this.modalProcess.no = null;
      this.modalProcess.fileList = [];
      this.modalProcess.description = null;
    }
  },
};
</script>

<style>
.ant-table-thead .ant-table-row-cell-break-word {
  text-align: center !important;
}

.ant-table-body {
  margin: 0px !important;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }

    &-tabs-content {
      flex: 1;
    }
  }
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
